import { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Tooltip from '../../../Tooltip';
import ChartBoxHolder from './ChartBoxHolder';
import TotalCapitalRaised from './TotalCapitalRaised';
import CorporateActions from './CorporateActions';
import SharesAllotment from './SharesAllotment';
import InvestorsHolder from './InvestorsHolder';

import { setWatchlistLoadStatus } from '../../../../actions/watchlistActions';

import Styles from './styles.module.scss';

const CapitalStructure = memo((props) => {
  const {
    slug, isDirectNumberPassed, companyNumber, isWatchlist,
  } = props;

  const dispatch = useDispatch();
  const step = useSelector((state) => state.watchlistReducer.wlPageLoadingStep);

  useEffect(() => {
    if (!isWatchlist || step === 'LOADED') {
      return;
    }

    dispatch(setWatchlistLoadStatus('LOADED'));
  }, [isWatchlist, step, dispatch]);

  if (isWatchlist && !slug) return null;

  const currentLegalEntity = isDirectNumberPassed
    ? companyNumber
    : (slug.legal_entities.find((f) => f.legal_entity_type === 'companieshouse-gb')
      || slug.legal_entities[0]).legal_entity_id;

  return (
    <div className={Styles['capital-structure']}>
      <div className={Styles['capital-structure-note']}>
        Data is machine-extracted. Please verify before making any decisions.
        <Tooltip
          newIcon
          hasBigScreenDesign
          isCentered
          dynamicPosition
          contentStyle={{ left: 0 }}
          className={Styles['capital-structure-note-tooltip']}
        >
          The data presented here is automatically extracted from the relevant documents
          filled by the companies. Some data may be inaccurately extracted.
          Accuracy and completeness should be verified before making decisions.
          {' '}
          <a href="/contact-us" rel="noreferrer">
            Contact us
          </a>
          {' '}
          to notify us of errors and concerns.
        </Tooltip>
      </div>
      <ChartBoxHolder
        companyNumber={currentLegalEntity}
        isWatchlist={isWatchlist}
      />
      <TotalCapitalRaised
        companyNumber={currentLegalEntity}
        isWatchlist={isWatchlist}
      />
      <CorporateActions
        companyNumber={currentLegalEntity}
        isWatchlist={isWatchlist}
      />
      <SharesAllotment
        companyNumber={currentLegalEntity}
        isWatchlist={isWatchlist}
      />
      <InvestorsHolder
        companyNumber={currentLegalEntity}
        isWatchlist={isWatchlist}
      />
    </div>
  );
});

export default CapitalStructure;
